<template>
  <div>
    <source-info v-if="formSource.providerId=='wechat-work'" :formSource="formSource" :add="true"></source-info>
    <orcid-info v-else-if="formSource.providerId=='orcid'"  :formSource="formSource" :add="true"></orcid-info>
    <scan-info v-else-if="formSource.providerId=='wechat_open' || formSource.providerId=='weibo' || formSource.providerId=='wechat_mp'"  :formSource="formSource" :add="true"></scan-info>
    <ding-info v-else-if="formSource.providerId=='ding_talk'"  :formSource="dingFormSource" :add="true"></ding-info>
    <cas-info v-else :formSource="casformSource" :add="true"></cas-info>
  </div>
</template>

<script>
import sourceInfo from "@/components/certificationSource/sourceInfo.vue"
import casInfo from "@/components/certificationSource/casInfo.vue"
import orcidInfo from "@/components/certificationSource/orcidInfo.vue"
import scanInfo from "@/components/certificationSource/scanInfo.vue"
import dingInfo from "@/components/certificationSource/dingInfo.vue"
export default {
  components: {
    sourceInfo,
    casInfo,
    orcidInfo,
    scanInfo,
    dingInfo
},
  data() {
    return {
      breadcrumb: [
        {
          label: "认证源",
          url: "/certificationSource"
        },
        {
          label: "添加认证源"
        }
      ],
      formSource: {
        providerId: "",
        name: "",
        enabled: true,
        clientId: "",
        agentId: "",
        secret: "",
        wxip: location.host,
        // haveAccount: "0",
        // noAccount: "0",
        createMethod: "1"
      },
      casformSource: {
        providerId: "",
        name: "",
        enabled: true,
        casServerUrlPrefix: "",
        createMethod: "1"
      },
      dingFormSource: {
        providerId: "ding_talk",
        name: "钉钉扫码登录",
        enabled: true,
        clientId: "",
        agentId: "",
        secret: "",
        wxip: location.host,
        createMethod: "2"
      },
      realmName: this.$realm, //this.$realm,
      sourceID: null
    }
  },
  created() {
    let id =  this.$route.query.sourceID, name = this.$route.query.name, form = null
    if(id !== 'cas'){
      form = this.formSource
    } else {
      form = this.casformSource
    }
    form.providerId = id
    form.name = name
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss">
.padding-title {
  padding-left: 26px;
}
</style>
